import type { ParsedToken } from 'firebase/auth'
import type { CustomClaims } from '~/types/users'

const state = reactive({
  claims: null,
})

export default () => {
  const setClaims = (newClaims: (ParsedToken & CustomClaims) | null) => {
    state.claims = newClaims
  }

  return {
    ...toRefs(state),
    setClaims,
  }
}
